export default __webpack_public_path__ + "static/desktop_2-6149fa57ed0332f66090708eea9602ad.webp";